import React, {useEffect} from 'react';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const Toast = () => {
    const [{ latest_system_notification_name,latest_system_notification_UUID }, {}, {}] = useDOMAttachToSystemStore();
    useEffect(() => {
        if (latest_system_notification_name === 'toast') {
        }
    }, [latest_system_notification_UUID]);
    return (
        <>
        </>
    )
};

export default Toast;
